import PromoDetailsConfig from '../table/configs/promoDetailsConfig.json';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {ConfirmationDialogComponent} from '../repair-details/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {ToastMessagesService} from '../services/toast-messages.service';

@Component({
  templateUrl: './promo-details.component.html'
})
export class PromoDetailsComponent implements OnInit {
  promoDetailsConfig: any;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  promoDetails: any;
  user: any;

  constructor(private authService: AuthService,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    this.promoDetails = JSON.parse(localStorage.getItem('promoDetails'));
    this.promoDetailsConfig = PromoDetailsConfig;
  }

  public async ngOnInit(): Promise<any> {
    this.user = await this.authService.getUser();
    await this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.showBasicInfo = true;
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Αριθμός Εντολής',
          value: this.promoDetails.id
        }
      ],
      title: 'Πληροφορίες Εντολής Διαφημιστικού Υλικού'
    };

    await this.initializeActions();
  }


  private async initializeActions() {
    const actions = [];

    const action1 = {
      function: () => {
        this.initializeConfirmPromoCancellationDialog(this.promoDetails);
      },
      showAction: this.canShowCancellationButton(),
      title: 'Ακύρωση Εντολής Διαφημιστικού Υλικού',
      icon: 'block',
      color: '#013e81',
    };
    actions.push(action1);

    const action2 = {
      function: () => {
        this.initializeConfirmCancellationDialog(this.promoDetails);
      },
      showAction: this.canShow(),
      title: 'Διαγραφή Εντολής Διαφημιστικού Υλικού',
      icon: 'cancel',
      color: 'red'
    };
    actions.push(action2);

    const action3 = {
      function: () => {
        this.downloadPDF();
      },
      showAction: true,
      title: 'Λήψη PDF',
      icon: 'picture_as_pdf',
      color: '#013e81',
    };
    actions.push(action3);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  canShow() {
    if (this.promoDetails.status_id === 1) {
      return true;
    }

    if (this.promoDetails.created_by_role_id === 4 && this.promoDetails.type_id === 6 && this.promoDetails.status_id === 6) {
      return true;
    }

    if (this.promoDetails.created_by_role_id === 4 && this.promoDetails.status_id === 5 && this.promoDetails.type_id !== 6) {
      return true;
    }
  }

  canShowCancellationButton() {
    return this.promoDetails.status_id !== 9 && (this.user.role_id === 1 || this.user.role_id === 10);
  }

  async downloadPDF() {
    try {
      await this.commonService.getPDF(`pdf?model=promo_request&id= ${this.promoDetails.id}`,
        `Εντολή Διαφημιστικού Υλικού - ${this.promoDetails.id}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private async initializeConfirmCancellationDialog(details) {
    const cancellationDialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να διαγράψετε την εντολή διαφημιστικού υλικού με αριθμό ${details.id}?`,
        title: 'Διαγραφή Εντολής Διαφημιστικού Υλικού'
      }
    });

    cancellationDialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.cancelRequest(details);
      }
    });
  }

  private async initializeConfirmPromoCancellationDialog(details) {
    const cancellationDialog = this.matDialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να ακυρώσετε την εντολή διαφημιστικού υλικού με αριθμό ${details.id}?`,
        title: 'Ακύρωση Εντολής Διαφημιστικού Υλικού'
      }
    });

    cancellationDialog.afterClosed().subscribe(async (response) => {
      if (response) {
        await this.cancelPromoRequest(details);
      }
    });
  }

  private async cancelRequest(details) {
    try {
      await this.commonService.deleteItem(`promo_material_request/web`, details.id);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      await this.router.navigate(['promo']);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private async cancelPromoRequest(details) {
    try {
      await this.commonService.updateObject(`promo_material_request/cancel/${details.id}`, null);
      this.toastMessagesService.toastMessages('Η ακύρωση ολοκληρώθηκε με επιτυχία');
      await this.router.navigate(['promo']);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
